import { FC } from 'react'
import cx from 'classnames'

import { SearchAndFilterProps } from '../SearchAndFilter'
import { PaginationProps } from '../Pagination'

import * as SC from './styled'
import { LexiconLetterProps } from './Letter'

export type LexiconProps = {
  className?: string
  searchAndFilterProps?: SearchAndFilterProps
  letters?: LexiconLetterProps[]
  paginationProps?: PaginationProps
}

const Lexicon: FC<LexiconProps> = ({
  className,
  letters,
  searchAndFilterProps,
  paginationProps,
}) => {
  return (
    <SC.Container className={cx('Lexicon', className)}>
      {searchAndFilterProps && (
        <SC._SearchAndFilter {...searchAndFilterProps} />
      )}
      <SC.List>
        {letters?.map((letter, index) => (
          <SC._LexiconLetter key={index} {...letter} htmlTag="li" />
        ))}
      </SC.List>
      {paginationProps && (paginationProps.pageCount ?? 0) > 1 && (
        <SC._Pagination {...paginationProps} />
      )}
    </SC.Container>
  )
}

export default Lexicon
